import React from 'react';
import { connect } from 'react-redux';
// import FontIcon from 'react-toolbox/lib/font_icon';
import { get } from '~/actions/orderNew';
// import Tag from '~/components/Tag';
import Title from '~/components/Title';
import style from './style.scss';

class Order extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.load();
  }

  load() {
    if (!this.props.id || !this.props.item) {
      this.setState({ loading: false });
      return;
    }

    get(this.props.dispatch, this.context.apiClient, this.props.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderItem() {
    const order = this.props.item.toJS();
    return (
      <div onClick={() => this.context.dialogPush('order', { id: order.id })}>
        <Title>Order #{order.sku} ({order.reference})</Title>
        <div>Containers:
          <span style={{ float: 'right' }}>
            {Object.values(this.props.containers).length}
          </span>
        </div>
        {order.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    const { item, className } = this.props;
    return (
      <div className={[style.container, className].join(' ')}>
        <div className={style.content}>
          {this.state.loading && 'Loading'}
          {!this.state.loading && !item && '404'}
          {!this.state.loading && item && this.renderItem()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const item = state.getIn(['orderNew', 'items', props.id]);
  const containers = state.getIn(['containers', 'items'])
    .filter(i => i.get('orderId') === props.id)
    .toJS();
  return { item, containers };
};

export default connect(mapStateToProps)(Order);



// WEBPACK FOOTER //
// ./app/components/Order/index.js